import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import * as Sentry from "@sentry/react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Quiz from "./pages/Quiz";
import { PrivacyPolicy } from "./components/legal/PrivacyPolicy";
import { TermsOfService } from "./components/legal/TermsOfService";
import { CookiePolicy } from "./components/legal/CookiePolicy";
import { GDPRStatement } from "./components/legal/GDPRStatement";
import { ErrorFallback } from "./components/ErrorFallback";
import "./i18n/config";

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <BrowserRouter>
            <Routes>
            <Route path="/" element={
              <>
                <Index />
                <PrivacyPolicy />
                <TermsOfService />
                <CookiePolicy />
                <GDPRStatement />
              </>
            } />
            <Route path="/privacy" element={
              <>
                <Index />
                <PrivacyPolicy />
              </>
            } />
            <Route path="/terms" element={
              <>
                <Index />
                <TermsOfService />
              </>
            } />
            <Route path="/cookies" element={
              <>
                <Index />
                <CookiePolicy />
              </>
            } />
            <Route path="/gdpr" element={
              <>
                <Index />
                <GDPRStatement />
              </>
            } />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        </Sentry.ErrorBoundary>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
